import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils
import axios from '../../utils/axios';
import { DeliveryOptionsType } from '../../@types/deliveryOptionsType';
import URLConstants from 'constants/urlConstants';

type DeliveryOptionsState = {
    isLoading: boolean;
    error: boolean;
    deliveryOptions: DeliveryOptionsType[];
}

const initialState: DeliveryOptionsState = {
    isLoading: false,
    error: false,
    deliveryOptions: [],
}

const slice = createSlice({
    name: 'deliveryOptions',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // GET DELIVERY OPTIONS
        getDeliveryOptionsSuccess(state, action) {
            state.isLoading = false;
            state.deliveryOptions = action.payload;
        },
    }
});

// Reducer
export default slice.reducer;


export function getDeliveryOptions() {
    return async () => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.get(URLConstants.DELIVERY_OPTIONS_BASE_URL);
        dispatch(slice.actions.getDeliveryOptionsSuccess(response.data.data));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
  }